var _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerdmsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "194.7,204.2 145.3,204.2 129.8,7.8 210.5,7.8 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M240.2,53.6l-24.4,35.4c44,17.4,75,59.5,75,108.2c0,64.5-54.4,117-121.1,117s-121.1-52.5-121.1-117 c0-48.7,31-90.8,75-108.2L99.2,53.6C44.1,79.2,5.5,134,5.5,197.5c0,87.9,73.7,159.1,164.5,159.1s164.5-71.2,164.5-159.1 C334.5,134,295.9,79.2,240.2,53.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerdmsLogo);
export default __webpack_public_path__ + "static/media/powerdms-logo.6a727a60f28448daa1cde320649e7b45.svg";
export { ForwardRef as ReactComponent };